import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PawPrintIcon as PawPrint, XIcon as X } from "@phosphor-icons/react";

/**
 * Warm first-visit welcome strip for campaign traffic (influencer / TV).
 * Logged-out visitors only; dismissed state persists in localStorage.
 */
const KEY = "campaign-welcome-dismissed";

export default function CampaignWelcomeBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
  });
  const [isAuthed] = useState(() => {
    try { return !!localStorage.getItem("token"); } catch { return false; }
  });
  if (dismissed || isAuthed) return null;
  const dismiss = () => {
    try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    setDismissed(true);
  };
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-40 bg-ink text-white px-4 py-3 sm:py-2.5 shadow-[0_-6px_20px_rgba(0,0,0,0.3)] pb-[max(0.75rem,env(safe-area-inset-bottom))]"
      data-testid="campaign-welcome-banner"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-center gap-3 flex-wrap text-center pr-8">
        <p className="text-[12.5px] sm:text-[13px] leading-snug">
          <PawPrint size={14} weight="fill" className="inline -mt-0.5 mr-1.5 text-gold" />
          <span className="font-bold">New here? Welcome!</span>{" "}
          Armstrong K9 Registry is where dogs get verified pedigrees, buyers get
          scam-proof payments, and every pup finds their people.
        </p>
        <Link
          to="/register"
          className="flex-shrink-0 rounded-full bg-gold text-ink text-[12px] font-bold px-4 py-1.5 hover:bg-white transition-colors"
          data-testid="campaign-welcome-cta"
        >
          Join free →
        </Link>
      </div>
      <button
        onClick={dismiss}
        aria-label="Dismiss welcome banner"
        className="absolute right-3 top-1/2 -translate-y-1/2 h-7 w-7 rounded-full hover:bg-white/10 flex items-center justify-center text-white/70 hover:text-white transition-colors"
        data-testid="campaign-welcome-dismiss"
      >
        <X size={14} weight="bold" />
      </button>
    </div>
  );
}
